import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=212153b6"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default})
